$(".realizations__item, .gallery__item").on("click", (ev) => {
	ev.preventDefault();
});
